import styled from 'styled-components';
import { TextFieldContainer } from "../../TextField/TextField.styles";
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.neutralL5;
}};
  ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.fonts.infoSM;
}};
  margin-top: 10px;
`;
export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 10px;
  margin-right: 10px;

  span {
    margin-right: 5px;
    white-space: nowrap;
  }

  & > ${TextFieldContainer} {
    width: 80px;
    padding-bottom: 10px; // distância de padding-top do input, para alinhar com os outros elementos do pagination
  }

  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  button {
    background-color: transparent;
    border: none;
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;